"use strict";
var validators_1 = require("./validators");
var moment = require("moment");
var Mapper = (function () {
    function Mapper() {
    }
    /**
     * Copy values from source onto target only if there is a new value
     * @param source Object to pull data from
     * @param target Object to copy data to
     */
    Mapper.copyValues = function (source, target) {
        if (typeof source === 'object') {
            if (source instanceof (Array)) {
                for (var i = 0; i < source.length; i++) {
                    target[i] = defaultTargetToMatchSource(source[i], target[i]);
                    target[i] = Mapper.copyValues(source[i], target[i]);
                }
            }
            else {
                for (var property in source) {
                    if (source.hasOwnProperty(property)) {
                        target[property] = defaultTargetToMatchSource(source[property], target[property]);
                        target[property] = Mapper.copyValues(source[property], target[property]);
                    }
                }
            }
            return target;
        }
        else {
            if (typeof source === 'undefined') {
                return target;
            }
            else {
                return Mapper.emptyToNull(source);
            }
        }
        function defaultTargetToMatchSource(source, target) {
            if (typeof target === 'undefined') {
                if (typeof source === 'object') {
                    if (source instanceof (Array)) {
                        return [];
                    }
                    else {
                        return {};
                    }
                }
            }
            else {
                return target;
            }
        }
    };
    Mapper.emptyToNull = function (value) {
        if (value === '') {
            return null;
        }
        else {
            return value;
        }
    };
    Mapper.fromParseFormatToDisplayFormat = function (parseFormat) {
        var date = moment(parseFormat, validators_1.Constants.DATE_PARSE_FORMAT);
        return date.format(validators_1.Constants.DATE_DISPLAY_FORMAT);
    };
    Mapper.fromDisplayFormatToParseFormat = function (displayDate) {
        var date = moment(displayDate, validators_1.Constants.DATE_DISPLAY_FORMAT);
        return date.format(validators_1.Constants.DATE_PARSE_FORMAT);
    };
    return Mapper;
}());
exports.Mapper = Mapper;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/mapper.helper.js